module.exports = __webpack_public_path__ + "static/img/leftDownOne.a3e5350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/matrixImg/leftDownOne.png
// module id = QDoa
// module chunks = 0